<div class="widget" [ngClass]="{'loader-shown': loading, 'failed-to-load': failedToLoad}" #timeline>
  <div class="widget-failed-to-load" [attr.aria-hidden]="failedToLoad ? 'false' : 'true'">
    <div class="content">
      <div class="content-inner">
        <span class="icon material-icons" aria-hidden="true">priority_high</span>
        <h3 class="title">Error</h3>
        <p class="text-content">Unable to load data. Please try again.</p>
      </div>
      <button class="button button-secondary button-secondary--smaller" (click)="reloadWidget()" aria-label="Reload Widget">Reload</button>
    </div>
  </div>
  <div class="widget-loader widget-loader-timeline" [attr.aria-hidden]="loading ? 'false' : 'true'">
    <div class="widget-loader-header">
      <div class="loader-element loader-icon"></div>
      <div class="loader-element loader-title"></div>
      <div class="loader-element loader-right-icon"></div>
    </div>
    <div class="widget-loader-content">
      <div class="loader-element loader-countdown"></div>
      <div class="loader-element loader-title"></div>
      <div class="loader-element loader-date"></div>
      <div class="loader-element loader-timeline-bar">
        <div class="loader-element loader-circle"></div>
        <div class="loader-element loader-circle"></div>
        <div class="loader-element loader-circle"></div>
        <div class="loader-element loader-circle"></div>
      </div>
    </div>
    <div class="widget-loader-bottom">
        <div class="loader-element loader-button"></div>
        <div class="loader-element loader-button-left"></div>
        <div class="loader-element loader-button-right"></div>
    </div>
  </div>
  <div class="widget-header" [attr.aria-hidden]="failedToLoad ?? loading ? 'true' : 'false'">
    <span class="custom-icon">
      <span class="icon material-icons">schedule</span>
    </span>
    <span class="title">Timeline</span>
    <a
      *ngIf="widgetConfig.widgetSettings.showFullTimelineButton"
      href="{{FEUrl}}/timeline"
      target="_blank"
      class="full-timeline-link"
      pTooltip="Full Timeline"
      aria-label="Explore the full timeline"
    >
      <span class="icon material-icons" aria-hidden="true">launch</span>
    </a>
  </div>
  <div class="widget-content" [attr.aria-hidden]="failedToLoad ?? loading ? 'true' : 'false'">
    <p-carousel
      [value]="timelineSlides"
      [showIndicators]="false"
      [numVisible]="1"
      [numScroll]="1"
      (onPage)="onSlideChange($event)"
      [page]="firstSlideIndex"
    >
      <ng-template let-slide pTemplate="item">
        <div
          class="item-inner"
          [ngClass]="{'not-active': slide.index !== this.activeSlideIndex, 'active': slide.index === this.activeSlideIndex}"
          [ariaLabel]="slide.title"
          [attr.aria-hidden]="slide.index === this.activeSlideIndex ? 'false' : 'true'"
        >
          <div class="timeline-countdown-wrapper" *ngIf="slide.showCountdown">
            <span
              class="timeline-countdown"
              [ngClass]="slide.calculatedCountdownClass"
            >
              {{ slide.calculatedCountdownText }}
            </span>
          </div>
          <h5 class="timeline-title">{{ slide.title }}</h5>
          <p class="timeline-date">{{ slide.dateLabel }}</p>
          <span class="button-container">
            <ng-container *ngIf="slide.showAddToCalendarButton">
              <button
                class="slide-button"
                [id]="'add-to-calendar-' + slide.title"
                (click)="addToCalendarClick(slide)"
                [tabIndex]="slide.index === this.activeSlideIndex ? '' : '-1'"
                [ariaLabel]="'Add ' + slide.title + ' date to your callendar'"
              >
                Add to Calendar
              </button>
            </ng-container>
            <ng-container *ngIf="!slide.showAddToCalendarButton && (slide.buttonUrl && slide.buttonText)">
              <a
                class="slide-button"
                [href]="slide.buttonUrl"
                target="_blank"
                [tabIndex]="slide.index === this.activeSlideIndex ? '' : '-1'"
              >
                {{ slide.buttonText }}
              </a>
            </ng-container>
          </span>
        </div>
      </ng-template>
    </p-carousel>
    <button class="button-timeline-prev" (click)="slidePrev()" [disabled]="activeSlideIndex === 0" aria-label="Previous timeline slide">
      <span class="icon material-icons">chevron_left</span>
    </button>
    <button class="button-timeline-next" (click)="slideNext()" [disabled]="activeSlideIndex === timelineSlides.length - 1" aria-label="Next timeline slide">
      <span class="icon material-icons">chevron_right</span>
    </button>
    <div class="timeline-bar-wrapper">
      <div
        class="timeline-line"
        [ngStyle]="{'transform': 'translateX(-' + timelineMilestoneBarPosition + '%)'}"
        [ngClass]="{
          'timeline-line--50': widgetConfig.widgetHorizontalPercentageSize === 50,
          'timeline-line--66': widgetConfig.widgetHorizontalPercentageSize === 66.66666,
          'timeline-line--100': widgetConfig.widgetHorizontalPercentageSize === 100
        }"
      >
        <ng-container *ngFor="let slide of timelineSlides, let i = index">
          <div
            class="timeline-line-point"
            [ngStyle]="{'left': slide.milestonePositionInPercent + '%'}"
            [ngClass]="{'active': i === activeSlideIndex, 'passed': slide.milestonePassed === true}"
          >
            <span class="point"></span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>